import { useQuery } from '@tanstack/react-query';
import { getPaymentMethods } from '@/services/subscription.service';
import { queryKeys } from '@/hooks/queries/keys';

export const usePaymentMethods = (options?: { enabled?: boolean }) => {
    return useQuery({
        queryKey: queryKeys.subscription.paymentMethods(),
        queryFn: getPaymentMethods,
        enabled: options?.enabled ?? true,
    });
};
